import { signOut, useSession } from "next-auth/react";
import { setUser } from "@sentry/nextjs";

import useImpersonate from "./useImpersonate";
import { LocalStorageHelper } from "utils/localstorage";
import { queryClient } from "@utils";

export default () => {
    const session = useSession();
    const sessionLoading = session.status === "loading";
    if (session.status === "authenticated") {
        setUser(session!.data!.user as any);
    }

    const { stopImpersonating } = useImpersonate();

    const logout = async () => {
        await stopImpersonating();
        await signOut({ redirect: false });
        LocalStorageHelper.clearAll();
        queryClient.invalidateQueries();
        queryClient.clear();
        const returnTo = `${window.location.origin}/login`;
        const logoutUrl = `${process.env.NEXT_PUBLIC_AUTH0_ISSUER_BASE_URL}/v2/logout?client_id=${process.env.NEXT_PUBLIC_AUTH0_CLIENT_ID}&returnTo=${encodeURIComponent(returnTo)}`;

        window.location.href = logoutUrl;
    };

    // Just a shortcut, email is used often
    const userEmail = session.data?.user?.email ?? null;

    return {
        session: {
            ...session.data!,
            // // For backwards compatibility
            isAdmin: session?.data?.isAdmin ?? false,
        },
        sessionLoading,
        logout,
        userEmail,
    };
};
